/**
 * Resolve the deep-link route for a system notification.
 *
 * The backend writes `entityType` in PascalCase (e.g. `SalesOrder`,
 * `RecountOrder`) while routes are kebab-case, so we normalize and map
 * explicitly. Anything unmapped (or missing entity info) falls back to the
 * `/notifications` list — never a non-existent `/notifications/:id`, which is
 * what produced the "page not found" on click.
 */
export function resolveSystemNotificationPath(
  entityType?: string | null,
  entityId?: string | null,
): string {
  // Kitchens → Acumatica failure alerts: every one (a row, or the bridge
  // itself with no entity id) opens the Needs attention list.
  if (entityType?.toLowerCase() === 'kitchenacumatica') {
    return '/kitchens/acumatica?tab=attention';
  }

  if (!entityType || !entityId) {
    return '/notifications';
  }

  switch (entityType.toLowerCase()) {
    case 'salesorder':
      return `/sales-orders/${entityId}`;
    case 'recountorder':
      return `/recount/${entityId}`;
    case 'purchaseorder':
    case 'poreceipt':
    case 'poreceiptdraft':
      return `/purchase-orders/${entityId}`;
    case 'item':
    case 'stockitem':
    case 'nonstockitem':
      return `/inventory/${entityId}`;
    default:
      return '/notifications';
  }
}
